/*
 * @Author: your name
 * @Date: 2020-07-23 19:21:00
 * @LastEditTime: 2020-07-23 19:23:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/lib/ui/components/x-input/index.js
 */
import XArea from './x-area.vue';

XArea.install = (vue) => {
  vue.component(XArea.name, XArea)
}

export default XArea
